//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
export default {
  components: {
    panel: panel
  },
  props: {
    currentType: {
      type: String,
      default: ''
    },
    updateType: {
      type: String,
      default: ''
    },
    deadDate: {
      type: String,
      default: ''
    }
  }
};